import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  FaSearch,
  FaLaptopCode,
  FaBolt,
  FaUndo,
} from "react-icons/fa";

import { technologyIcon } from "../../../../Assessment/component/assessment/technologyIcon";
import { getQuizTestsList } from "../../../actions";

/* -------------------- Constants -------------------- */

const CATEGORY_DATA = ["Assessment", "Test"];
const DIFFICULTY_LEVELS = [
  "Beginner",
  "Intermediate",
  "Advanced",
  "Expert",
];

/* -------------------- Component -------------------- */

const QuizzesFilters = () => {
  const dispatch = useDispatch();
  const searchTimeoutRef = useRef(null);

  const [filters, setFilters] = useState({
    search: "",
    quizTechnology: "",
    level: "",
    category: "",
  });

  /* -------------------- Handlers -------------------- */

  const updateFilter = (key) => (e) => {
    const value = e.target.value;

    setFilters((prev) => {
      // Start with previous filters
      const updated = {
        ...prev,
        [key]: value,
      };

      // Create API payload (remove "All" values)
      const apiFilters = Object.fromEntries(
        Object.entries(updated).filter(
          ([_, val]) => val !== "All" && val !== ""
        )
      );

      dispatch(getQuizTestsList({ filter: apiFilters })); //variable ko object ke formate mai bhjna hai key = filter
      return updated;                           //at all places
    });
  };

  const handleSearchChange = (e) => {
    const rawValue = e.target.value;
    const trimmedValue = rawValue.trim();

    const updatedFilters = {
      ...filters,
      search: rawValue, // keep raw value in input
    };

    setFilters(updatedFilters);

    // Clear previous debounce
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // 🔴 Case 1: Only spaces → do nothing
    if (rawValue !== "" && trimmedValue === "") {
      return;
    }

    // 🟢 Case 2: Search cleared (backspace to empty) → reset API
    if (rawValue === "") {
      searchTimeoutRef.current = setTimeout(() => {
        dispatch(getQuizTestsList({ filter: apiFilters }));
      }, 300);
      return;
    }

    // Create API payload (remove "All" values)
    const apiFilters = Object.fromEntries(
      Object.entries({
        ...updatedFilters,
        search: trimmedValue, // send trimmed value to API
      }).filter(([_, val]) => val !== "All" && val !== "")
    );

    // Debounce API call
    searchTimeoutRef.current = setTimeout(() => {
      dispatch(getQuizTestsList({ filter: apiFilters }));
    }, 400);
  };


  const handleReset = () => {
    const resetFilters = {
      search: "",
      quizTechnology: "All",
      level: "All",
      category: "All",
    };

    // Create API payload (remove "All" values)
    const apiFilters = Object.fromEntries(
      Object.entries(resetFilters).filter(
        ([_, val]) => val !== "All" && val !== ""
      )
    );

    setFilters(resetFilters);
    dispatch(getQuizTestsList({ filter: apiFilters }));
  };

  /* -------------------- JSX -------------------- */

  return (
    <div className="card-quizzes mb-5 mx-md-5 mx-3 animate-slide-up backdrop-blur-20px">
      <div className="card-body p-4">
        <div className="row mx-0 g-3 align-items-end">

          {/* Search */}
          <div className="col-md-3">
            <label className="text-white fw-semibold mb-2">
              <FaSearch color="skyblue" size={20} /> Search Quizzes
            </label>
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Search by Title or Tags"
              value={filters.search}
              onChange={handleSearchChange}
            />
          </div>

          {/* Technology */}
          <div className="col-md-3">
            <label className="text-white fw-semibold mb-2">
              <FaLaptopCode color="skyblue" size={20} /> Technology
            </label>
            <select
              className="form-select form-select-lg"
              value={filters.quizTechnology}
              onChange={updateFilter("quizTechnology")}
            >
              <option value="All">All</option>
              {technologyIcon.map((tech) => (
                <option
                  key={tech.technologyName}
                  value={tech.technologyName.toLowerCase()}
                  className="text-capitalize"
                >
                  {tech.technologyName}
                </option>
              ))}
            </select>
          </div>

          {/* Difficulty */}
          <div className="col-md-2">
            <label className="text-white fw-semibold mb-2">
              <FaBolt color="skyblue" size={20} /> Difficulty
            </label>
            <select
              className="form-select form-select-lg"
              value={filters?.level}
              onChange={updateFilter("level")}
            >
              <option value="All">All</option>
              {DIFFICULTY_LEVELS.map((level) => (
                <option key={level} value={level.toLowerCase()}>
                  {level}
                </option>
              ))}
            </select>
          </div>

          {/* Category */}
          <div className="col-md-2">
            <label className="text-white fw-semibold mb-2">
              <FaLaptopCode color="skyblue" size={20} /> Category
            </label>
            <select
              className="form-select form-select-lg"
              value={filters.category}
              onChange={updateFilter("category")}
            >
              <option value="All">All</option>
              {CATEGORY_DATA.map((category) => (
                <option key={category} value={category.toLowerCase()}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          {/* Reset */}
          <div className="col-md-2">
            <button
              className="btn btn-lg w-100 text-white border-0 reset-btn"
              onClick={handleReset}
            >
              <FaUndo color="skyblue" /> Reset
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default QuizzesFilters;
